import { useState, useEffect, useRef,useContext } from "react";
import { Container, Label, Row, Col, NavLink } from "reactstrap";
import moment from "moment";
import {Decimal} from 'decimal.js';
import Select from "react-select";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { NavLink as RRNavLink } from "react-router-dom";
import {LineChart} from 'amazing-react-charts'
import { CLOSE_IMAGE } from "../Componentes/Image";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { ComponentToPrintsReporteVentas, ComponentToPrintsReporteCreditos,ComponentToPrintsReporteIC,ComponentToPrintsReporteVM,ComponentToPrintsReportePVM,ComponentToPrintsReporteUM, ComponentToPrintsReporteInventarioEx, ComponentToPrintsReportePV, ComponentToPrintsGastos } from "../Inventario/ComponentToPrintss";
import ReactToPrint from "react-to-print-advanced";
import CloseIcon from '@mui/icons-material/Close';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ClearIcon from '@mui/icons-material/Clear';
import BarChartIcon from '@mui/icons-material/BarChart';
import { IconButton,Button,Box } from "@mui/material";
import { DateRangeModal } from "../Componentes/Modal";
import { MDBIcon, MDBTabs, MDBTabsLink, MDBTabsContent, MDBTabsPane, MDBInput, MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import {EXPORT_CSV_CREDITOS_PAGO,EXPORT_CSV_CREDITOS, FORMATO_AM_PM, format_miles} from "./../Componentes/Util";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "./../Componentes/www/style.css";
import {DATATABLE_CREDITOS_PAGO,DATATABLE_CREDITOS, DATATABLE_EXSITENCIA_INVENTARIO, DATATABLE_CLIENTES_REPORTE, DATATABLE_CLIENTES_HISTORIAL} from "./../Componentes/Datatables";
import {get_report_existencia_inventario, get_report_historial_clientes,get_report_creditos,get_report_venta, get_report_x_global,get_report_ventas_mensuales,get_report_productos_masvendidos,get_report_utilidad_margen, get_compania_all, get_report_productos_vendidos, get_cli_cliente, get_gas_gastos_range} from "./../Componentes/Services";
import{monthname} from "../Componentes/Services";
import StoreContext from "./../Componentes/Store/Context";
import { STATES_CLI_CLIENTES } from "../Componentes/States";
export const Reporte = () => {
  var subtotal = 0;
  var itbms = 0;
  var total = 0;
  var total_ventas_r = 0;
  var total_totales = 0;
  var creditos =0;
  var exento = 0;
  var objeDataTotales = [];
  var componentRef = useRef();
  var vendedorChecked = false;
  
  const [flagGraficaGastos, setOpenFlagGastos] = useState(false);
  const [monto_gastos, setMontoGastos] = useState("");
  const [tabsActive, setTabsActive] = useState("tab1");
  const [isPrinting, setPrintI] = useState(false);
  const [isDateRangeOpen, setDateRange] = useState(false);
  const [isPrintingC, setPrintIC] = useState(false);
  const [isPrintingRC, setPrintRC] = useState(false);
  const [isPrintingVM, setPrintVM] = useState(false);
  const [isPrintingPVM, setPrintPMV] = useState(false);
  const [isPrintingUM, setPrintUM] = useState(false);
  const [isPrintingGastos, setPrintGastos] = useState(false);
  const [isPrintingVendidos, setPrintVendidos] = useState(false);
  const [isPrintingInventarioEx, setPrintInventarioEx] = useState(false);
  const [isOpenHistorialClientes, setHistorialClientes] = useState(false);
  const [dataClientes, setDataClientes] = useState([]);
  const [formClientes, setFormClientes] = useState(STATES_CLI_CLIENTES("formClientes"));
    const [dataCompany, setDataCompania] = useState({
    com_id:"",
    com_nombre: "",
    com_alias:"",
    com_ruc: "",
    com_dv: "",
    com_direccion: "",
    com_telefono: "",
    com_telefono2: "",
    com_email: "",
    com_fax: "",
    com_web: "",
    com_info_interes:"",
    com_cotizacion_info:"",
    com_cot_image:"",
    com_res_image:"",
    com_instagram:"",
    com_tiktok:"",
    com_facebook:"",
    com_existencia_v:""
  });
  const [dataChartGastos, setChartGastos] = useState([]);
  const [dataReporteInformeCaja, setReportInformeCaja] = useState([]);
  const [flagReporteCreditos, setOpenReporteCreditos] = useState(false);
  const [flagInfomeCaja, setOpenFlagInformeCaja] = useState(false);
  const [flagProductosMasVendidos, setFlagProductosMasVEndidos] = useState(false);
  const [flagUtilidadMargen, setFlagUtilidadMargen] = useState(false);
  const [flagGastos, setFlagGastos] = useState(false);
  const [flagGraficaVentasMensuales, setFlagVentasMensuales] = useState(false);
  const [dataReporteCreditos, setReportCreditos] = useState([]);
  const [dataReportePagoCreditos, setReportPagoCreditos] = useState([]);
  const [dataReporteVentasExento, setReportVentaExento] = useState([]);
  const [dataReporteVentas, setReportVenta] = useState([]);
  const [dataReporteVentasFpago, setReportVentaFpago] = useState([]);
  const [dataReporteVentasMontosT, setReportVentaMontosT] = useState([]);
  const [dataReporteVentasCreditos, setReportVentaCreditos] = useState([]);
  const [dataObjCompania, setObjCompania] = useState([]);
  const [sucursalSelected, setSucursal] = useState("");
  const [suc_sucursal, setSuc_sucursal] = useState("");
  const [dataReportVentasMensuales, setReportVentasMensuales] = useState([]);
  const [dataReportUtilidadMargen, setReportUtilidadMargen] = useState([]);
  const [dataReportGastos, setReportGastos] = useState([]);
  const [dataExistenciaInv, setDataExistenciaI] = useState([]);
  const [dataReporProductosVendidos, setReportProductosMasVendidos] = useState([]);
  const [dataReporProductosV, setReportProductosVendidos] = useState([]);
  const [dataHistorialClientes, setDataHistorialClientes] = useState([]);
  const { usr_key_login,dataCompania,usr_sucursal,quitToken} = useContext(StoreContext);
  const [open, setOpen] = useState(false);
  const [flag, setOpenFlag] = useState(0);
  const [state, setState] = useState([{
    startDate: moment(new Date()).format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
    key: "selection"
  }]);
    const csvConfigRV = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
    filename: "reporte_de_productos_vendidos"+moment(new Date()).format("_YYYY_MM_DD")+".csv",
  });
  
  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
    filename: "reporte_de_ventas"+moment(new Date()).format("_YYYY_MM_DD")+".csv",
  });
  
  const handleExportCsvCredito = () => {
    EXPORT_CSV_CREDITOS({dataCreditos:dataReporteCreditos})
  };

  const handleExportCsvPago = () => {
    EXPORT_CSV_CREDITOS_PAGO({dataCreditospago:dataReportePagoCreditos})
  };
    const onChangeDropdown = (selectedOptions) => {
    dataObjCompania.find((data)=>{
      if(data.com_id === selectedOptions.value){
        setDataCompania({
          com_nombre: data.com_nombre,
          com_alias: data.com_alias,
          com_ruc: data.com_ruc,
          com_dv: data.com_dv,
          com_direccion: data.com_direccion,
          com_telefono: data.com_telefono,
          com_telefono2: data.com_telefono2,
          com_email: data.com_email,
          com_fax: data.com_fax,
          com_web: data.com_web,
          com_info_interes:data.com_info_interes,
          com_cotizacion_info:data.com_cotizacion_info,
          com_cot_image:data.com_cot_image,
          com_instagram:data.com_instagram,
          com_tiktok:data.com_tiktok,
          com_facebook:data.com_facebook,
          com_id:data.com_id,
          com_existencia_v:data.com_existencia_v
        });
        setSuc_sucursal(data.com_id)
        setSucursal(data.com_alias);
      }
    })
  };
  useEffect(() => {
    fetchCompania()
    fetchCliente()
    if(dataCompania.count ==="0"){
        quitToken()
      }
  }, []);
    const handleExportDataRv = () => {
    var report_v= dataReporProductosV.map((data,i)=>{
      return{
        Codigo:data.art_upc,
        Articulo:data.art_descripcion,
        Categoria:data.cat_descripcion,
        Fecha:FORMATO_AM_PM(new Date(data.fac_fecha)),
        Caja:data.caj_descripcion,
        Vendedor:data.usr_nombre,
        Cantidad:data.cantidad,
        Costo:Number(Number(data.art_costo)*(1+Number(data.art_itbm_compra))).toFixed(2),
        Precio:data.fcd_precio,
        ITBMS:data.fcd_itbms,
        Total_costo:Number((Number(data.art_costo)*Number(data.cantidad))*(1+Number(data.art_itbm_compra))).toFixed(2),
        Total_venta:Number(data.fac_total).toFixed(2),
        Total:Number(data.fac_total).toFixed(2),
        Utilidad:(Number(data.fac_total)-((Number(data.art_costo)*Number(data.cantidad))*(1+Number(data.art_itbm_compra)))).toFixed(2),
      }
    });

    const csv = generateCsv(csvConfigRV)(report_v);
    download(csvConfigRV)(csv);
  };
  const handleExportData = () => {
    var report_v= dataReporteVentas.map((data,i)=>{
    var fpago ="";
    dataReporteVentasFpago.map((datap, i) => {
      if (data.fac_id === datap.fac_id) {
        fpago = fpago +" "+datap.fcfp_pago+" "+datap.fcfp_monto;
      }
      return null;
    });
      return{
        ID:data.fac_id,
        Fecha:data.fac_fecha,
        Cliente:data.cli_nombre,
        Vendedor:data.usr_nombre,
        Caja:data.fac_caja,
        Fecha_anulacion:data.fac_date_anulacion,
        Anulacion:data.fac_anulacion !== "1" ? "" : "ANULADO",
        Exento:data.fcd_itbms_code==="00"?"Exento":"",
        forma_pago:fpago,                                    
        Subtotal:data.fcd_precio,
        Itbms:data.fcd_itbms,
        Total:data.fcd_total
      }
    })
    const csv = generateCsv(csvConfig)(report_v);
    download(csvConfig)(csv);
  };
  async function fetchCliente() {
    var response;
    response = await get_cli_cliente(usr_sucursal);
    setDataClientes(response);
  }
    async function fetchGastos({date1,date2}) {
      var response = await get_gas_gastos_range({date1,date2,usr_sucursal});
      setReportGastos(response.gastos);
      setMontoGastos(response.monto[0]);
      var dataChart = response.gastos.map((data,i)=>{
            return{
              label:data.tgs_desc,
              result: data.gs_monto,
              mes:monthname[Number(moment(data.gs_fecha).month())-1].name,
              itemId: 1,
            }
            //  
          });
          setChartGastos(dataChart)
    }
  async function fetchCompania() {
    var response;
    var result;
    var flag_result = false;
    // if(usr_perfil==="1"){
      response = await get_compania_all();
      setObjCompania(response);
      if(dataCompania.com_id.length>0){
      result = response.filter((data)=>{
        if(data.com_id === dataCompania.com_id){
          
            flag_result = false;
            return data
        }
        return null
      })
      }
      else{
        result = response[0];
        flag_result = true;
      }
      if(!flag_result){
        result = result[0];
      }
       setDataCompania({
        com_nombre: result.com_nombre,
        com_alias:result.com_alias,
        com_ruc: result.com_ruc,
        com_dv: result.com_dv,
        com_direccion: result.com_direccion,
        com_telefono: result.com_telefono,
        com_telefono2: result.com_telefono2,
        com_email: result.com_email,
        com_fax: result.com_fax,
        com_web: result.com_web,
        com_info_interes:result.com_info_interes,
        com_cotizacion_info:result.com_cotizacion_info,
        com_cot_image:result.com_cot_image,
        com_instagram:result.com_instagram,
        com_tiktok:result.com_tiktok,
        com_facebook:result.com_facebook,
        com_id:result.com_id,
        com_existencia_v:result.com_existencia_v
      });
      setSucursal(result.com_alias)
      setSuc_sucursal(result.com_id)
  }

  dataReporteVentasMontosT.map((data) => {

    // if(data.)
      itbms = Number(data.fcd_itbms)
      total =  Number(data.fcd_total)
      subtotal = Number(total) - Number(itbms)
      return null
  })

  if(dataReporteVentasExento[0]!==undefined){
    exento=Number(dataReporteVentasExento[0].fcd_total);
  }
  if(dataReporteVentasCreditos[0]!==undefined){
    creditos=Number(dataReporteVentasCreditos[0].crd_monto);
  }

  objeDataTotales = {
    itbms,
    subtotal,
    total,
    exento,
    startDate: moment(state[0].startDate).format("YYYY-MM-DD"),
    Endate: moment(state[0].endDate).format("YYYY-MM-DD"),
  }

  const handleTabClick = (value) => {
   
    if (value === tabsActive) {
      return;
    }
    setReportVentaCreditos([]);
    setReportVentaMontosT([]);
    setReportVentaExento([]);
    setTabsActive(value);
    setOpenFlagInformeCaja(false)
    setReportVenta([]);
    setReportInformeCaja([]);
    setReportPagoCreditos([]);
 
    setReportProductosVendidos([]);
    setReportProductosMasVendidos([]);
    setReportUtilidadMargen([]);
    setDataExistenciaI([]);
    setHistorialClientes(false);
    setPrintI(false)
    setPrintIC(false)
    if(value==="tab8"){
      fetchExistencia()
    }
  };
  
  async function fetchProductosVendidos({ startDate, endDate }) {
    var response = await get_report_productos_vendidos({startDate, endDate});
    response = response.map((data,i)=>{
      return{...data,
        label: data.art_descripcion,
        result: data.cantidad,
      }
    })
    setReportProductosVendidos(response);
  }
  async function fetchProductosMasvendidos({ startDate, endDate }) {
    var response = await get_report_productos_masvendidos({startDate, endDate});
    response = response.map((data,i)=>{
      return{...data,
        label: data.art_descripcion,
        result: data.cantidad,
      }
    })
    setReportProductosMasVendidos(response);
  }

  async function fetchUtilidadMargen({ startDate, endDate }) {
    var response = await get_report_utilidad_margen({startDate, endDate});
    // response = response.map((data,i)=>{
    //   return{
    //     label: monthname[data.fac_fecha].name,
    //     result: data.fac_total,
    //     itbms: data.fac_itbms,
    //     itemId: 1,
    //   }
    // })
    setReportUtilidadMargen(response);
  }

  async function fetchVentasMensuales({ startDate, endDate }) {
    var response = await get_report_ventas_mensuales({startDate, endDate,suc_sucursal});

    response = response.ventas_mensuales.map((data,i)=>{
      return{
        label: monthname[Number(data.fac_fecha)-1].name,
        result: data.fac_total,
        itbms: data.fac_itbms,
        itemId: 1,
      }
    })
    setReportVentasMensuales(response);
  }
  
  async function fetchReporteCreditos({ startDate, endDate }) {
    var response = await get_report_creditos({startDate, endDate,suc_sucursal});
    setReportCreditos(response.reporte_creditos);
    setReportPagoCreditos(response.reporte_pagoCredito);
    setOpenReporteCreditos(true);
  }

  async function find_historial(cli_id) {
    var response;
    response = await get_report_historial_clientes(cli_id);
    setDataHistorialClientes(response);
  }

  async function fetchReporte({ startDate, endDate }) {
    var response = await get_report_venta(startDate, endDate,suc_sucursal);

    setReportVenta(response.ventas_global);
    setReportVentaFpago(response.fPago);
    setReportVentaExento(response.exento);
    setReportVentaMontosT(response.montos_totales);
    setReportVentaCreditos(response.creditos)
    
    // var report = [];
    // var hashReport = {};
    // report = response.ventas_global.filter((o) => (hashReport[o.usr_id] || o.usr_id === null ? false : (hashReport[o.usr_id] = true)));
    // setGroupVendedor(report)
  }

  async function fetchReporteInformeCaja({ startDate, endDate }) {
    var response = await get_report_x_global(startDate, endDate,suc_sucursal);
    setReportInformeCaja(response);
    response.montos_totales[0] !== undefined ? setOpenFlagInformeCaja(true) : setOpenFlagInformeCaja(false);
  }

  async function fetchExistencia() {
    var response = await get_report_existencia_inventario();
    setDataExistenciaI(response);
  }

  const handleOnChangeDate = (ranges) => {
    const { selection } = ranges;
    setOpenFlag(Number(flag) + 1)
    setState([selection]);
    if (flag === 1) {
      if(tabsActive === "tab1"){
        fetchReporte({ startDate: moment(selection.startDate).format("YYYY-MM-DD"), endDate: moment(selection.endDate).format("YYYY-MM-DD"), group_vendedor: vendedorChecked })
      }
      if(tabsActive === "tab2") {
        fetchReporteInformeCaja({ startDate: moment(selection.startDate).format("YYYY-MM-DD"), endDate: moment(selection.endDate).format("YYYY-MM-DD") })
      }
      if(tabsActive === "tab3") {
        fetchReporteCreditos({ startDate: moment(selection.startDate).format("YYYY-MM-DD"), endDate: moment(selection.endDate).format("YYYY-MM-DD") })
      }
      if(tabsActive === "tab4") {
        fetchVentasMensuales({ startDate: moment(selection.startDate).format("YYYY-MM-DD"), endDate: moment(selection.endDate).format("YYYY-MM-DD") })
      }
      if(tabsActive === "tab5") {
        fetchProductosMasvendidos({ startDate: moment(selection.startDate).format("YYYY-MM-DD"), endDate: moment(selection.endDate).format("YYYY-MM-DD") })
      }
      if(tabsActive === "tab6") {
        fetchProductosVendidos({ startDate: moment(selection.startDate).format("YYYY-MM-DD"), endDate: moment(selection.endDate).format("YYYY-MM-DD") })
      }
      if(tabsActive === "tab7") {
        fetchGastos({ date1: moment(selection.startDate).format("YYYY-MM-DD"), date2: moment(selection.endDate).format("YYYY-MM-DD") })
        // fetchUtilidadMargen({ startDate: moment(selection.startDate).format("YYYY-MM-DD"), endDate: moment(selection.endDate).format("YYYY-MM-DD") })
      }
      setOpen(false);
      setOpenFlag(0)
      setDateRange(false)
      setOpenFlagInformeCaja(false);
      setFlagProductosMasVEndidos(false);
      setOpenReporteCreditos(false)
    }
  };

  var objCompania = []
    dataObjCompania.map((comp) => {
    objCompania.push({
      value: comp.com_id,
      label: comp.com_alias,
    });
    return comp;
  });

  return (
    <Container fluid  className="font-s12px">
      {isDateRangeOpen && (
        <DateRangeModal
          isOpen={isDateRangeOpen}
          toggle={setDateRange}
          show_year_month={false}
          open={open}
          handleOnChangeDate={handleOnChangeDate}
          state={state}
        />
      )}
      <>
      <Row>
        <Col xs={11}>
          <MDBTabs className="d-flex-none custom-navs">
            <Row>
              <Col xs={12} className="mt-3">
                <Row>
                <Col xs={1} >
                  <MDBTabsLink onClick={() => handleTabClick("tab1")} active={tabsActive === "tab1"} className="padding-2porc">
                    <MDBIcon fas icon="money-bill" className="me-2" /> Ventas
                  </MDBTabsLink>
                </Col>
                <Col xs={2}>
                  <MDBTabsLink onClick={() => handleTabClick("tab2")} active={tabsActive === "tab2"} className="padding-2porc">
                    <MDBIcon fas icon="cash-register" className="me-2" /> Informes de caja
                  </MDBTabsLink>
                </Col>
                <Col xs={1}>
                <MDBTabsLink onClick={() => handleTabClick("tab3")} active={tabsActive === "tab3"} className="padding-2porc">
                    <MDBIcon fas icon="cash-register" className="me-2" /> Créditos
                  </MDBTabsLink>
                  </Col>
                <Col xs={2}>
                  <MDBTabsLink onClick={() => handleTabClick("tab4")} active={tabsActive === "tab4"} className="padding-2porc">
                    <MDBIcon fas icon="cash-register" className="me-2" /> Ventas mensuales
                  </MDBTabsLink>
                </Col>
                <Col xs={2}>
                  <MDBTabsLink onClick={() => handleTabClick("tab5")} active={tabsActive === "tab5"} className="padding-2porc">
                    <MDBIcon fas icon="cash-register" className="me-2" /> Productos más vendidos
                  </MDBTabsLink>
                </Col>
                <Col xs={2}>
                  <MDBTabsLink onClick={() => handleTabClick("tab6")} active={tabsActive === "tab6"} className="padding-2porc">
                    <MDBIcon fas icon="chart-line" className="me-2" /> Productos vendidos
                  </MDBTabsLink>
                </Col>
                <Col xs={1} className="d-flex">
                  <MDBTabsLink onClick={() => handleTabClick("tab7")} active={tabsActive === "tab7"} className="padding-2porc">
                    <MDBIcon fas icon="cash-register" className="me-2" /> Gastos
                  </MDBTabsLink>
                </Col>
                <Col xs={2} className="d-flex">
                  <MDBTabsLink onClick={() => handleTabClick("tab8")} active={tabsActive === "tab8"} className="padding-2porc">
                    <MDBIcon fas icon="box" className="me-2" /> Inventario
                  </MDBTabsLink>
                  
                </Col>
                </Row>
              </Col>
             <Col xs={12} className="mt-3">
            <Row>
              <Col xs={4} className="d-flex">
                  <MDBTabsLink onClick={() => handleTabClick("tab9")} active={tabsActive === "tab9"} className="padding-2porc">
                    <MDBIcon fas icon="box" className="me-2" /> Historial de clientes
                  </MDBTabsLink>
                 
                </Col>
                <Col xs={8}></Col>
            </Row>
            </Col>
          </Row>
        </MDBTabs>
        </Col>
        <Col xs={1}>
        <NavLink tag={RRNavLink} to="/user/home" className="font-w-bold   menu-l-c padding-2porc">
                  <img src={CLOSE_IMAGE} className="src-image" alt="..."/>
                  </NavLink>
        </Col>
      </Row>

        <MDBTabsContent>
          <Row>
            <Col xs={4}></Col>
            <Col xs={4} className="text-center">

              {
              tabsActive==="tab1" ||tabsActive==="tab2" ||tabsActive==="tab3" ||tabsActive==="tab4"?
              objCompania.length>1 ?<Select
                options={objCompania}
                onChange={onChangeDropdown}
                placeholder={sucursalSelected}
              />:"":""}
            </Col>
            <Col xs={4}></Col>
          </Row>
          <MDBTabsPane show={tabsActive === "tab1"}>
            {
              isPrinting ?
                <>
                  <Row>
                    <Col xs={10}></Col>
                    <Col xs={2} >
                      <IconButton className="float-right-btn"
                        onClick={() => {
                          setPrintI(false);
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                      <ReactToPrint
                        trigger={() => <button className="btn-print">   <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                        content={() => componentRef} />
                    </Col>
                    <Col xs={12} className="text-center scrol-table2">
                      <ComponentToPrintsReporteVentas
                        ref={el => (componentRef = el)}
                        props={dataReporteVentas}
                        dataReporteVentasFpago={dataReporteVentasFpago}
                        objeData={objeDataTotales}
                        formCompania={dataCompania}
                        sucursalSelected={sucursalSelected}
                      />
                    </Col>
                  </Row>
                </> :
                <>
                  <Row>
                    <Col xs={3}></Col>
                    <Col xs={6} >
                    <Row className="mb-1 mt-2">
                      <Col xs={12} className="text-center"><Label className="font-weight-bold-title">REPORTE DE VENTAS - {sucursalSelected}</Label></Col> 
                    </Row>
                      

                    </Col>
                    <Col xs={3}></Col>
                    <Col xs={2}>
                      <MDBInput
                        className="input-iventario-totales imput-price-color2"
                        label="SUBTOTAL"
                        autoFocus={true}
                        value={dataReporteVentas.length > 0 ? Number(Number(subtotal)).toFixed(2) : ""}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={2}>
                      <MDBInput
                        className="input-iventario-totales imput-price-color2"
                        wrapperClass="mb-4"
                        label="ITBMS"
                        value={dataReporteVentas.length > 0 ? itbms.toFixed(2) : ""}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={2}>
                      <MDBInput
                        className="input-iventario-totales imput-price-color"
                        id="fcd_i_total_e"
                        label="EXENTO"
                        value={dataReporteVentas.length > 0 ? exento.toFixed(2) : ""}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={2}>
                      <MDBInput
                        className="input-iventario-totales imput-price-color"
                        id="fcd_i_creditos"
                        label="CRÉDITOS"
                        value={dataReporteVentas.length > 0 ? creditos.toFixed(2) : ""}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={2}>
                      <MDBInput
                        className="input-iventario-totales imput-price-color2"
                        id="fcd_i_total"
                        label="TOTAL"
                        value={dataReporteVentas.length > 0 ? total.toFixed(2) : ""}
                        disabled={true}
                      />
                    </Col>
                      {/* <Col xs={4}></Col> */}
                    <Col xs={2} className="d-flex">
                    <Row>
                      <Col xs={12} className="text-center">
                      {dataReporteVentas[0] === undefined ? null :
                                          <>
                                          <IconButton
                                            className="position-icon" 
                                              onClick={() => {
                                                setPrintI(true);
                                              }}
                                            >
                                              <LocalPrintshopIcon />
                                            </IconButton>
                                          
                                          <Button className="position-icon" 
                                      //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                      onClick={handleExportData}
                                      startIcon={<FileDownloadIcon />}
                                    >
                                      CSV
                                    </Button></> 

                      }
                      <IconButton className="position-icon" onClick={() => {
                        setOpen(true); setDateRange(true); setState([{
                          startDate: moment(new Date()).format("YYYY-MM-DD"),
                          endDate: moment(new Date()).format("YYYY-MM-DD"),
                          key: "selection"
                        }])
                      }}>

                        <CalendarMonthIcon />
                      </IconButton>
  </Col>
  <Col xs={12} className="text-center">
  {state[0].startDate !== "" && state[0].endDate !== "" && (
                        <p className="date-p-label">{" "}
                          {moment(state[0].startDate).format("YYYY-MM-DD")} {" - "}
                          {moment(state[0].endDate).format("YYYY-MM-DD")}
                        </p>
                      )}
  </Col>
</Row>

                    </Col>


                    <Col xs={12}>
                      {open ? null :
                        <>
                          {dataReporteVentas[0] !== undefined ? <>

                            <Row>
                              <Col xs={12} className="scrol-table">
                                <MDBTable striped className="custom-table">
                                  <MDBTableHead dark className="table-dark-custom">
                                    <tr>
                                      <th className="text-center">N° DOCUMENTO</th>
                                      <th className="text-center">FECHA</th>
                                      <th className="text-center">CLIENTE</th>
                                      <th className="text-center">VENDEDOR</th>
                                      <th className="text-center">CAJA</th>
                                      <th className="text-center">FECHA ANULADO</th>
                                      <th className="text-center">ANULACIÓN</th>
                                       {/* <th className="text-center w-500px">EXENTO</th> */}
                                      <th className="text-center">SUBTOTAL</th>
                                      <th className="text-center">ITBMS</th>
                                      <th className="text-center">F. PAGO</th>
                                      <th className="text-centerx">TOTAL</th>
                                    </tr>
                                  </MDBTableHead>
                                  <MDBTableBody>

                                    {
                                      dataReporteVentas.map((data, i) => {
                                        return <tr key={i}>
                                          <td className="text-center">
                                            <Label>{data.fac_id.toString().padStart(10, "0")}</Label>
                                          </td>
                                          <td className="text-center">
                                            <Label>{data.fac_fecha}</Label>
                                          </td>
                                          <td className="text-start">
                                            <Label>{data.cli_nombre}</Label>
                                          </td>
                                          <td className="text-start">
                                            <Label>{data.usr_nombre}</Label>
                                          </td>
                                          <td className="text-center">
                                            <Label>{data.fac_caja}</Label>
                                          </td>
                                          <td className="text-center">
                                            <Label>{data.fac_date_anulacion}</Label>
                                          </td>
                                          <td className="text-center">
                                            <Label>{data.fac_anulacion !== "1" ? "" : "ANULADO"}</Label>
                                          </td>
                                          {/* <td className="text-center">
                                            <Label>{data.fcd_itbms_code==="00"?"Exento":null}</Label>
                                          </td> */}

                                          <td className="text-end">
                                            <Label className="padding-r">$ {format_miles({num:data.fcd_precio})}</Label>
                                          </td>
                                          <td className="text-end">
                                            <Label className="padding-r">$ {format_miles({num:data.fcd_itbms})}</Label>
                                          </td>
                                          <td className="text-start">
                                            {
                                              dataReporteVentasFpago.map((datap, i) => {
                                                if (data.fac_id === datap.fac_id) {
                                                  return <><Label className="label-fpago">&nbsp;&nbsp;&nbsp;{datap.fcfp_pago}{" "}{datap.fcfp_monto}</Label></>
                                                }
                                                return null;
                                              })
                                            }
                                          </td>
                                          <td className="text-end">
                                            <Label className="padding-r">$ {format_miles({num:data.fcd_total})}</Label>
                                          </td>
                                        </tr>
                                      })
                                    }
                                  </MDBTableBody>
                                </MDBTable>

                              </Col>
                            </Row>
                          </>
                            : null}
                        </>
                      }
                    </Col>
                  </Row>
                </>
            }
          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab2"}>
            {isPrintingC ?
              <>
                <Row>
                  <Col xs={10}></Col>
                  <Col xs={2}>
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setPrintIC(false);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>

                    <ReactToPrint
                      trigger={() => <button className="btn-print"> <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                      content={() => componentRef} />
                  </Col>
                  <Col xs={12} className="text-center scrol-table2">
                    <ComponentToPrintsReporteIC
                      ref={el => (componentRef = el)}
                      dataReporteInformeCaja={dataReporteInformeCaja}
                      formCompania={dataCompania}
                      sucursalSelected={sucursalSelected}
                      startDate={moment(state[0].startDate).format("YYYY-MM-DD")}
                      endDate={moment(state[0].endDate).format("YYYY-MM-DD")}
                    />
                  </Col>
                </Row>
              </> :
              <>
                <Row>
                  <Col xs={12} className="text-center mt-3">
                    <Label className="font-weight-bold-title">REPORTE DE INFORMES DE CAJA  - {sucursalSelected}</Label>
                  </Col>
                  <Col xs={9} className="text-end">
                    {flagInfomeCaja === false ? null : <IconButton
                      onClick={() => {
                        setPrintIC(true);
                      }}
                    >
                      <LocalPrintshopIcon />
                    </IconButton>
                    }
                    <IconButton onClick={() => {
                      setOpen(true); setDateRange(true); setState([{
                        startDate: moment(new Date()).format("YYYY-MM-DD"),
                        endDate: moment(new Date()).format("YYYY-MM-DD"),
                        key: "selection"
                      }])
                    }}>
                      <CalendarMonthIcon />
                    </IconButton>

                  </Col>
                  <Col xs={3} className="text-right">
                    {state[0].startDate !== "" && state[0].endDate !== "" && (
                      <p className="date-p-label float-right-btn">Fecha : {" "}
                        {moment(state[0].startDate).format("YYYY-MM-DD")} {" - "}
                        {moment(state[0].endDate).format("YYYY-MM-DD")}
                      </p>
                    )}
                  </Col>
                  <Col>
                    {flagInfomeCaja ?
                      <>
                        <Row className="scrol-table3">
                          <Col xs={12} className="text-center">
                            <Label className="report-title">VENTAS REGISTRADAS</Label>
                            <MDBTable striped className="custom-table">
                              <MDBTableHead dark>
                                <tr>
                                  <th>CAJA</th>
                                  <th>FORMA DE PAGO</th>
                                  <th>MONTO</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReporteInformeCaja.montos_fpago.map((data, i) => {
                                    total_ventas_r = Number(total_ventas_r) + Number(data.fcfp_monto)
                                    return <tr>
                                      <td>{data.caj_descripcion}</td>
                                      <td>{data.fcfp_fpago}</td>
                                      <th className="text-end"><Label className="padding-r"> $ {format_miles({num:data.fcfp_monto})}</Label></th>
                                    </tr>
                                  })
                                }
                                <tr>
                                  <th></th>
                                  <th>TOTAL</th>
                                  <th className="text-end"><Label className="padding-r"> ${format_miles({num:total_ventas_r})}</Label></th>
                                </tr>
                              </MDBTableBody>
                            </MDBTable>

                          </Col>
                          <Col xs={12} className="text-center">
                            <Label className="report-title">TOTAL EXENTO DE ITBMS</Label>
                            <MDBTable striped className="custom-table">
                              <MDBTableHead dark>
                                <tr>
                                  <th>TOTAL</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReporteInformeCaja.exentos.map((data, i) => {
                                    return <tr>
                                      <td>$ {format_miles({num:data.fcd_total})}</td>
                                    </tr>
                                  })
                                }
                              </MDBTableBody>
                            </MDBTable>
                          </Col>
                          <Col xs={12} className="text-center">
                            <Label className="report-title">ANULACIONES REGISTRADAS</Label>
                            <MDBTable striped className="custom-table">
                              <MDBTableHead dark>
                                <tr>
                                  <th>CAJA</th>
                                  <th>VENDEDOR</th>
                                  <th>NÚMERO DE DOCUMENTO</th>
                                  <th>EMITIDO</th>
                                  <th>ANULADO</th>
                                  <th>TOTAL</th>
                                  <th>MOTIVO</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReporteInformeCaja.anulacion.map((data, i) => {
                                    return <tr>
                                      <th  className="text-start">{data.caj_descripcion}</th>
                                      <th className="text-start">{data.usr_nombre}</th>
                                      <td  className="text-start">{data.fac_id}</td>
                                      <th>{data.fac_fecha}</th>
                                      <td>{data.fac_date_anulacion}</td>
                                      <th className="text-end"><Label className="padding-r">$ {format_miles({num:data.fcd_total})}</Label></th>
                                      <td  className="text-start">{data.fac_motivo_anulacion}</td>
                                    </tr>
                                  })
                                }
                                
                              </MDBTableBody>
                            </MDBTable>
                          </Col>
                          <Col xs={12} className="text-center">
                            <Label className="report-title">TOTALES</Label>
                            <MDBTable striped className="custom-table">
                              <MDBTableHead dark>
                                <tr>
                                  <th>CAJA</th>
                                  <th>VENTAS SUBTOTAL</th>
                                  <th>ITBMS</th>
                                  <th>TOTAL</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReporteInformeCaja.montos_totales.map((data, i) => {
                                    total_totales = Number(total_totales) + Number(data.fcd_total)
                                    return <tr>
                                       <td className="text-start">{data.caj_descripcion}</td>
                                      <td  className="text-end" ><Label className="padding-r">$ {format_miles({num:data.fcd_precio})}</Label> </td>
                                      <td  className="text-end"><Label className="padding-r">$ {format_miles({num:data.fcd_itbms})}</Label> </td>
                                      <th className="text-end"><Label className="padding-r">$ {format_miles({num:data.fcd_total})}</Label></th>
                                    </tr>
                                  })
                                }
                                <tr>
                                  <th></th>
                                  <th></th>
                                  {/* <th></th> */}
                                  <th>TOTAL</th>
                                  <th className="text-end"><Label className="padding-r">$ {format_miles({num:total_totales})}</Label></th>
                                </tr>
                              </MDBTableBody>
                            </MDBTable>
                          </Col>
                        </Row>

                      </> : null
                    }
                  </Col>
                </Row>
              </>
            }
          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab3"}>
            {isPrintingRC ?
              <>
                <Row>
                  <Col xs={10}></Col>
                  <Col xs={2}>
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setPrintRC(false);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>

                    <ReactToPrint
                      trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                      content={() => componentRef} />
                  </Col>
                  <Col xs={12} className="text-center scrol-table2">
                    <ComponentToPrintsReporteCreditos
                      ref={el => (componentRef = el)}
                      dataReporteCreditos={dataReporteCreditos}
                      dataReporteCreditosPago={dataReportePagoCreditos}
                      formCompania={dataCompania}
                      sucursalSelected={sucursalSelected}
                      startDate ={moment(state[0].startDate).format("YYYY-MM-DD")}
                      endDate={moment(state[0].endDate).format("YYYY-MM-DD")}
                    />
                  </Col>
                </Row>
              </> :
              <>
                <Row>
                  <Col xs={12} className="text-center mt-3">
                    <Label className="font-weight-bold-title">REPORTE DE CRÉDITOS  - {sucursalSelected}</Label>
                  </Col>
                  <Col xs={9} className="text-end">
                    {flagReporteCreditos === false ? null : <IconButton
                      onClick={() => {
                        setPrintRC(true);
                      }}
                    >
                      <LocalPrintshopIcon />
                    </IconButton>
                    }
                    <IconButton onClick={() => {
                      setOpen(true); setDateRange(true); setState([{
                        startDate: moment(new Date()).format("YYYY-MM-DD"),
                        endDate: moment(new Date()).format("YYYY-MM-DD"),
                        key: "selection"
                      }])
                    }}>
                      <CalendarMonthIcon />
                    </IconButton>

                  </Col>
                  <Col xs={3} className="text-right">
                    {state[0].startDate !== "" && state[0].endDate !== "" && (
                      <p className="date-p-label float-right-btn">Fecha : {" "}
                        {moment(state[0].startDate).format("YYYY-MM-DD")} {" - "}
                        {moment(state[0].endDate).format("YYYY-MM-DD")}
                      </p>
                    )}
                  </Col>
                  <Col>
                    {flagReporteCreditos ?
                      <>
                        <Row className="scrol-table3">
                          <Col xs={12} className="text-center modal-add-inventario datatable-factura">
                            <Label className="report-title">Créditos registrados</Label>
                            <DATATABLE_CREDITOS dataCreditos={dataReporteCreditos} handleExportData={handleExportCsvCredito}/>
                            {/* <MDBTable striped className="custom-table">
                              <MDBTableHead dark>
                                <tr>
                                  <th># FACTURA</th>
                                  <th>CLIENTE</th>
                                  <th>RUC</th>
                                  <th>MONTO</th>
                                  <th>FECHA</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReporteCreditos.map((data, i) => {
                                    return <tr>
                                      <th>{data.fac_id.toString().padStart(10, "0")}</th>
                                      <td>{data.cli_nombre}</td>
                                      <th>{data.cli_ruc}</th>
                                      <td>{data.crd_monto}</td>
                                      <th>{data.crd_fecha}</th>
                                    </tr>
                                  })
                                }
                              </MDBTableBody>
                            </MDBTable> */}

                          </Col>
                          <Col xs={12} className="text-center modal-add-inventario datatable-factura">
                            <Label className="report-title">ESTADO DE CUENTA</Label>
                            <DATATABLE_CREDITOS_PAGO dataCreditospago={dataReportePagoCreditos} handleExportData={handleExportCsvPago}/>
                            {/* <MDBTable striped className="custom-table">
                              <MDBTableHead dark>
                                <tr>
                                  <th># FACTURA</th>
                                  <th>CLIENTE</th>
                                  <th>RUC</th>
                                  <th>MONTO</th>
                                  <th>FECHA PAGO</th>
                                  <th>ELIMINADO</th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                {
                                  dataReportePagoCreditos.map((data, i) => {
                                    return <tr>
                                      <td>{data.fac_id.toString().padStart(10, "0")}</td>
                                      <td>{data.cli_nombre}</td>
                                      <td>{data.cli_ruc}</td>
                                      <td>{data.crp_monto}</td>
                                      <td>{data.crp_fecha}</td>
                                      <td>{data.crp_fecha_delete}</td>
                                    </tr>
                                  })
                                }
                              </MDBTableBody>
                            </MDBTable> */}
                          </Col>
                        </Row>

                      </> : null
                    }
                  </Col>
                </Row>
              </>
            }
          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab4"}>
            {isPrintingVM ?
              <>
                <Row>
                  <Col xs={10}></Col>
                  <Col xs={2}>
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setPrintVM(false);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>

                    <ReactToPrint
                      trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                      content={() => componentRef} />
                  </Col>
                  <Col xs={12} className="text-center scrol-table2">
                    <ComponentToPrintsReporteVM
                      ref={el => (componentRef = el)}
                      dataReportVentasMensuales={dataReportVentasMensuales}
                      endDate ={state[0].endDate}
                      startDate={state[0].startDate}
                      formCompania={dataCompania}
                      sucursalSelected={sucursalSelected}
                    />
                  </Col>
                </Row>
              </>:          <Row>
            <Col xs={12} className="text-center mt-3">
              <Label className="font-weight-bold-title">REPORTE VENTAS MENSUALES  - {sucursalSelected}</Label>
            </Col>
            <Col xs={9} className="text-end">
              <IconButton onClick={() => {
                setOpen(true); setDateRange(true); setFlagVentasMensuales(false);setState([{
                  startDate: moment(new Date()).format("YYYY-MM-DD"),
                  endDate: moment(new Date()).format("YYYY-MM-DD"),
                  key: "selection"
                }])
              }}>
                <CalendarMonthIcon />
              </IconButton>
              {flagGraficaVentasMensuales?<IconButton onClick={() => {setFlagVentasMensuales(false)}}>
                <ClearIcon />
              </IconButton>:<>
              {dataReportVentasMensuales[0] === undefined ? null :<><IconButton onClick={() => {setFlagVentasMensuales(true)}}>
                  <BarChartIcon />
                </IconButton>
                <IconButton
                  onClick={() => {
                    setPrintVM(true);
                  }}>
                  <LocalPrintshopIcon />
                </IconButton></>}
                
              </>
              }
            </Col>
            <Col xs={3} className="text-right">
                    {state[0].startDate !== "" && state[0].endDate !== "" && (
                      <p className="date-p-label float-right-btn">Fecha : {" "}
                        {moment(state[0].startDate).format("YYYY-MM-DD")} {" - "}
                        {moment(state[0].endDate).format("YYYY-MM-DD")}
                      </p>
                    )}
                  </Col>
            <Col xs={12} className="text-center">
            {flagGraficaVentasMensuales?
              <LineChart
              showBarLabel
              yComplement="$"
              xType="category"
              yType="value"
              colors={['red', 'green', 'blue']}
              title="REPORTE VENTAS MENSUALES"
              toolboxTooltip={{ saveAsImage: 'save' }}
              // tooltip={{ label: 'Equipamento', result: 'Disponibilidade' }}
              data={[{name:"Venta",values:dataReportVentasMensuales}]}
            />:
            dataReportVentasMensuales[0] !==undefined? <MDBTable striped className="custom-table">
              <MDBTableHead dark>
                <tr>
                  <th>Mes</th>
                  <th>ITBMS</th>
                  <th>Monto</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {
                  dataReportVentasMensuales.map((data, i) => {
                    return <tr>
                      <th>{data.label}</th>
                      <th>{data.itbms}</th>
                      <td>{data.result}</td>
                    </tr>
                  })
                }
              </MDBTableBody>
            </MDBTable>:null
            }

            </Col>
          </Row>}

          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab5"}>
            {isPrintingPVM ?
              <>
                <Row>
                  <Col xs={10}></Col>
                  <Col xs={2}>
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setPrintPMV(false);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>

                    <ReactToPrint
                      trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                      content={() => componentRef} />
                  </Col>
                  <Col xs={12} className="text-center scrol-table2">
                    <ComponentToPrintsReportePVM
                      ref={el => (componentRef = el)}
                      dataReporProductosVendidos={dataReporProductosVendidos}
                      endDate ={state[0].endDate}
                      startDate={state[0].startDate}
                      formCompania={dataCompania}
                    />
                  </Col>
                </Row>
              </>:          <Row>
            <Col xs={12} className="text-center mt-3">
              <Label className="font-weight-bold-title">PRODUCTOS MÁS VENDIDOS</Label>
            </Col>
            <Col xs={9} className="text-end">
              <IconButton onClick={() => {
                setOpen(true); setDateRange(true); setFlagProductosMasVEndidos(false);setState([{
                  startDate: moment(new Date()).format("YYYY-MM-DD"),
                  endDate: moment(new Date()).format("YYYY-MM-DD"),
                  key: "selection"
                }])
              }}>
                <CalendarMonthIcon />
              </IconButton>
              {flagProductosMasVendidos?<IconButton onClick={() => {setFlagProductosMasVEndidos(false)}}>
                <ClearIcon />
              </IconButton>:<>
               {dataReporProductosVendidos[0] !==undefined? <IconButton
                  onClick={() => {
                    setPrintPMV(true);
                  }}>
                  <LocalPrintshopIcon />
                </IconButton>:null}
              </>
              }
            </Col>
            <Col xs={3} className="text-right">
                    {state[0].startDate !== "" && state[0].endDate !== "" && (
                      <p className="date-p-label float-right-btn">Fecha : {" "}
                        {moment(state[0].startDate).format("YYYY-MM-DD")} {" - "}
                        {moment(state[0].endDate).format("YYYY-MM-DD")}
                      </p>
                    )}
                  </Col>
            <Col xs={12} className="text-center">
    
            {dataReporProductosVendidos[0] !==undefined? <Row className="scrol-table3"><MDBTable striped className="custom-table">
            <MDBTableHead dark>
              <tr>
                <th>CÓDIGO</th>
                <th>Artículo</th>
                <th>Marca</th>
                <th>Categoría</th>
                <th>Cantidad</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {
                dataReporProductosVendidos.map((data, i) => {
                  return <tr>
                    <td>{data.art_upc}</td>
                    <td>{data.art_descripcion}</td>
                    <th>{data.mar_descripcion}</th>
                    <th>{data.cat_descripcion}</th>
                    <td>{data.cantidad}</td>
                  </tr>
                })
              }
            </MDBTableBody>
          </MDBTable></Row>:null
            }

            </Col>
          </Row>}

          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab6"}>
            {isPrintingVendidos ?
              <>
                <Row>
                  <Col xs={10}></Col>
                  <Col xs={2}>
                    <IconButton className="float-right-btn"
                      onClick={() => {setPrintVendidos(false);}}>
                      <CloseIcon />
                    </IconButton>
                    <ReactToPrint
                      trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                      content={() => componentRef} />
                  </Col>
                  <Col xs={12} className="text-center scrol-table2">
                    <ComponentToPrintsReportePV
                      ref={el => (componentRef = el)}
                      dataReporProductosVendidos={dataReporProductosV}
                      endDate ={state[0].endDate}
                      startDate={state[0].startDate}
                      formCompania={dataCompania}
                    />
                  </Col>
                </Row>
              </>:<Row>
            <Col xs={12} className="text-center mt-3">
              <Label className="font-weight-bold-title">PRODUCTOS VENDIDOS</Label>
            </Col>
            <Col xs={9} className="text-end">
              <IconButton onClick={() => {
                setOpen(true); setDateRange(true); setFlagUtilidadMargen(false);setState([{
                  startDate: moment(new Date()).format("YYYY-MM-DD"),
                  endDate: moment(new Date()).format("YYYY-MM-DD"),
                  key: "selection"
                }])
              }}>
                <CalendarMonthIcon />
              </IconButton>
              {flagUtilidadMargen?<IconButton onClick={() => {setFlagUtilidadMargen(false)}}>
                <ClearIcon />
              </IconButton>:<>
              {dataReporProductosV[0] !==undefined? <IconButton
                  onClick={() => {
                    setPrintVendidos(true);
                  }}>
                  <LocalPrintshopIcon />
                </IconButton>:null}
                {dataReporProductosV[0] === undefined ? null :<Button 
                  //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                  onClick={handleExportDataRv}
                  startIcon={<FileDownloadIcon />}
                >
                  CSV
                </Button>}
                       
              </>
              }
            </Col>
            <Col xs={3} className="text-right">
                    {state[0].startDate !== "" && state[0].endDate !== "" && (
                      <p className="date-p-label float-right-btn">Fecha : {" "}
                        {moment(state[0].startDate).format("YYYY-MM-DD")} {" - "}
                        {moment(state[0].endDate).format("YYYY-MM-DD")}
                      </p>
                    )}
                  </Col>
            <Col xs={12} className="text-center">
            {dataReporProductosV[0] !==undefined? <Row className="scrol-table3"><MDBTable striped className="custom-table">
            <MDBTableHead dark>
              <tr>
                <th>CÓDIGO</th>
                <th>Artículo</th>
                <th>Categoría</th>
                <th>Fecha</th>
                <th>Caja</th>
                <th>Vendedor</th>
                <th>Cantidad</th>
                <th>Costo</th>
                <th>Precio</th>
                <th>ITBMS</th>
                <th>C. Total</th>
                <th>T. Venta</th>
                <th>Utilidad</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {
                dataReporProductosV.map((data, i) => {
                  return <tr>
                    <td className="text-start">{data.art_upc}</td>
                    <td className="text-start">{data.art_descripcion}</td>
                    <td className="text-start">{data.cat_descripcion}</td>
                    <td>{FORMATO_AM_PM(new Date(data.fac_fecha))}</td>
                    <th className="text-start">{data.caj_descripcion}</th>
                    <th className="text-start">{data.usr_nombre}</th>
                    <td>{data.cantidad}</td>
                    <td>{Number(Number(data.art_costo)*(1+Number(data.art_itbm_compra))).toFixed(2)}</td>
                    <td>{data.fcd_precio}</td>
                    <td>{ Number(data.fcd_itbms).toFixed(2)}</td>
                    <td>{Number((Number(data.art_costo)*Number(data.cantidad))*(1+Number(data.art_itbm_compra))).toFixed(2)}</td>
                    <td>{Number(data.fac_total).toFixed(2)}</td>
                    <td>{(Number(data.fac_total)-((Number(data.art_costo)*Number(data.cantidad))*(1+Number(data.art_itbm_compra)))).toFixed(2) }</td>
                  </tr>
                })
              }
            </MDBTableBody>
          </MDBTable></Row>:null
            }

            </Col>
          </Row>}

          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab7"}>
            {isPrintingGastos ?
              <>
                <Row>
                  <Col xs={10}></Col>
                  <Col xs={2}>
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setPrintGastos(false);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>

                    <ReactToPrint
                      trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                      content={() => componentRef} />
                  </Col>
                  <Col xs={12} className="text-center scrol-table2">
                    <ComponentToPrintsGastos
                      ref={el => (componentRef = el)}
                      dataReportGastos={dataReportGastos}
                      endDate ={state[0].endDate}
                      startDate={state[0].startDate}
                      formCompania={dataCompania}
                    />
                  </Col>
                </Row>
              </>:<Row className="mt-4">

            <Col sm={2} md={2} className="text-end">
              <MDBInput
                  className="input-iventario-totales"
                  label="TOTAL DE GASTOS"
                  autoFocus={true}
                  value={monto_gastos.gs_monto != null ? Number(Number(monto_gastos.gs_monto)).toFixed(2) : ""}
                  disabled={true}
                />
            </Col>
            <Col sm={8} md={8} className="text-center mt-3">
              <Label className="font-weight-bold-title">GASTOS</Label>
            </Col>
            <Col sm={2} md={2} className="text-center mt-3">
              
            </Col>
            <Col xs={9} className="text-end">
              <IconButton onClick={() => {
                setOpen(true); setDateRange(true); setFlagGastos(false);setState([{
                  startDate: moment(new Date()).format("YYYY-MM-DD"),
                  endDate: moment(new Date()).format("YYYY-MM-DD"),
                  key: "selection"
                }])
              }}>
                <CalendarMonthIcon />
              </IconButton>
              <IconButton onClick={() => {setOpenFlagGastos(true)}}>
                <BarChartIcon />
              </IconButton>
              {flagGastos?<IconButton onClick={() => {setFlagGastos(false)}}>
                <ClearIcon />
              </IconButton>:<>
              {dataReportGastos[0] !==undefined? <IconButton
                  onClick={() => {
                    setPrintGastos(true);
                  }}>
                  <LocalPrintshopIcon />
                </IconButton>:null}
              </>
              }
            </Col>
            <Col xs={3} className="text-right">
                    {state[0].startDate !== "" && state[0].endDate !== "" && (
                      <p className="date-p-label float-right-btn">Fecha : {" "}
                        {moment(state[0].startDate).format("YYYY-MM-DD")} {" - "}
                        {moment(state[0].endDate).format("YYYY-MM-DD")}
                      </p>
                    )}
                  </Col>
            <Col xs={12} className="text-center">
            {flagGraficaGastos?
        <Col xs ={12} className="text-end">
          <IconButton onClick={() => {setOpenFlagGastos(false)}}>
                <ClearIcon />
              </IconButton>
              <LineChart
              showBarLabel
              yComplement="$"
              xType="category"
              yType="value"
              colors={['red', 'green', 'blue']}
              title="GRÁFICA DE GASTOS MENSUALES"
              toolboxTooltip={{ saveAsImage: 'save' }}
              // tooltip={{ label: 'Equipamento', result: 'Disponibilidade' }}
              data={[{name:"Gastos",values:dataChartGastos}]}
            />
        </Col>:dataReportGastos[0] !==undefined? <Row className="scrol-table3"><MDBTable striped className="custom-table">
            <MDBTableHead dark>
              <tr>
                <th>ID</th>
                <th>SUCURSAL</th>
                <th>DESCRIPCIÓN</th>
                <th>MONTO</th>
                <th>TIPO DE GASTO</th>
                <th>FECHA</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {dataReportGastos.map((data, i) => {
                  return <tr className="m-height-40">
                    <td>{data.gs_id}</td>
                    <td>{data.com_alias}</td>
                    <th className="text-left">{data.gs_desc}</th>
                    <th>{Number(data.gs_monto).toFixed(2)}</th>
                    <td>{data.tgs_desc}</td>
                    <td>{data.gs_fecha}</td>
                  </tr>
                })
              }
            </MDBTableBody>
          </MDBTable></Row>:null}
            </Col>
          </Row>}

          </MDBTabsPane>
           <MDBTabsPane show={tabsActive === "tab8"}>
            {isPrintingInventarioEx ?
              <>
                <Row>
                  <Col xs={10}></Col>
                  <Col xs={2}>
                    <IconButton className="float-right-btn"
                      onClick={() => {
                        setPrintInventarioEx(false);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>

                    <ReactToPrint
                      trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                      content={() => componentRef} />
                  </Col>
                  <Col xs={12} className="text-center scrol-table2">
                    <ComponentToPrintsReporteInventarioEx
                      ref={el => (componentRef = el)}
                      dataExistenciaInv={dataExistenciaInv}
                      formCompania={dataCompania}
                    />
                  </Col>
                </Row>
              </>:          <Row>
            <Col xs={10} className="text-center mt-3">
              <Label className="font-weight-bold-title">Inventario</Label>
            </Col>
            <Col xs={2} className="text-end mt-3">
              {dataExistenciaInv[0] !==undefined? <IconButton
                  onClick={() => {
                    setPrintInventarioEx(true);
                  }}>
                  <LocalPrintshopIcon />
                </IconButton>:null}
            </Col>
            <Col xs={12} className="text-center datatable-factura">
            {dataExistenciaInv[0] !==undefined? <Row>
              <DATATABLE_EXSITENCIA_INVENTARIO dataExistenciaInv={dataExistenciaInv}/>
              </Row>:null
            }

            </Col>
          </Row>}

          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab9"}>
            <Row>
              {isOpenHistorialClientes === true?<>
              <Col xs={12} className="text-end"><Box >
                  <IconButton onClick={() => setHistorialClientes(false)} className="float-right">
                    <CloseIcon className="float-right" />
                  </IconButton>
                </Box>
              </Col>
               <Col className="modal-add-inventario datatable-factura mt-2">
                <DATATABLE_CLIENTES_HISTORIAL
                  dataHistorialClientes={dataHistorialClientes}
                />
              </Col>
              </>:<Col className="modal-add-inventario datatable-factura mt-2">
                <DATATABLE_CLIENTES_REPORTE
                  dataClientes={dataClientes}
                  setFormClientes={setFormClientes}
                  find_historial={find_historial}
                  setHistorialClientes={setHistorialClientes}
                />
              </Col>}
            </Row>
          </MDBTabsPane>
        </MDBTabsContent>
      </>
    </Container>
  )
}